"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdeaCardVote = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _TopicVoteCount = require("@insided/destination/uikit/TopicVoteCount");

var _UserContext = require("@insided/shared/services/UserContext");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Stateful vote button component.
 * Handles vote/unvote logic and state management.
 * Gets userId from CurrentUserContext only when needed.
 */
var IdeaCardVote = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeaCardVote, _Component);

  var _super = _createSuper(IdeaCardVote);

  function IdeaCardVote() {
    var _this;

    (0, _classCallCheck2.default)(this, IdeaCardVote);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      votes: _this.props.votes,
      currentUserVoted: _this.props.likedOrVotedByCurrentUser
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleVoteStatus", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(currentUserId) {
        var event;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (currentUserId) {
                  _context.next = 4;
                  break;
                }

                event = new CustomEvent('GuestUserAction');
                window.dispatchEvent(event);
                return _context.abrupt("return");

              case 4:
                if (!_this.state.currentUserVoted) {
                  _context.next = 10;
                  break;
                }

                _this.setState({
                  currentUserVoted: false,
                  votes: _this.state.votes - 1
                });

                _context.next = 8;
                return _axios.default.post("/community/api/ideas/".concat(_this.props.ideaId, "/unvote"));

              case 8:
                _context.next = 13;
                break;

              case 10:
                _this.setState({
                  currentUserVoted: true,
                  votes: _this.state.votes + 1
                });

                _context.next = 13;
                return _axios.default.post("/community/api/ideas/".concat(_this.props.ideaId, "/vote"));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(IdeaCardVote, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          votes = _this$state.votes,
          currentUserVoted = _this$state.currentUserVoted;
      return (0, _preact.h)(_UserContext.CurrentUserContext.Consumer, null, function (user) {
        return (0, _preact.h)(_TopicVoteCount.TopicVoteButton, {
          hasVoted: currentUserVoted,
          className: "add_spacing",
          onClick: function onClick() {
            return _this2.toggleVoteStatus(user.id);
          }
        }, (0, _preact.h)(_TopicVoteCount.VoteCountInner, {
          count: votes
        }), (0, _preact.h)(_TopicVoteCount.VoteTriangleIcon, null));
      });
    }
  }]);
  return IdeaCardVote;
}(_preact.Component);

exports.IdeaCardVote = IdeaCardVote;